<template>
  <div class="top-block-container">
    <div id="TopicBlock" class="row top-block">
      <top-menu></top-menu>
    </div>
    <div class="row course-title-image">
      <div class="col">
        <img class="img-fluid"
          v-if="course != null"
          v-bind:src="getCourseTitleImageSrc">
      </div>
    </div>
  </div>
</template>
<script>
  import {
    mapGetters,
    mapActions
  } from 'vuex'
  import { courseMixin } from './_Mixins'
  import TopMenu from '@/components/Menu/TopMenu'

  let Methods = require('../methods')
  //let imgPath = require('../assets/_course/')

  export default {
    data() {
      return {
        // series_id and course_id already move to mixin
        // series_id: this.$route.params.series_id,
        // course_id: this.$route.params.course_id,
        //course: null,
        course_title: [2, 0, 2],
      }
    },

    mounted() {
      // waitingCourseReady()
      //   .then(() => {
      //     console.log('waitingCourseReady...')
      //   })
    },

    mixins: [ courseMixin ],

    components: {
      'top-menu': TopMenu,
    },

    // updated () {
    //   console.log('updated...', this.serieses.length, this.$route)
    // },

    computed: {
      ...mapGetters([ 'Serieses' ]),

      serieses() {
        let _serieses = this.Serieses

        return this.prepareSerieses(_serieses)
      },
      // course: function(value) {
      //   if (value) {
      //     console.log('CourseBlockWithTopMenu.vue > watch > course : ', value)
      //   }
      // }
    },
  }

</script>



// WEBPACK FOOTER //
// src/components/CourseBlockWithTopMenu.vue